import { useSegment } from '~/composables/_next/useSegment';
export default defineNuxtPlugin(function () {
  var _useSegment = useSegment(),
    loadSegment = _useSegment.loadSegment;
  loadSegment();

  // Event are sent by GTM for now so GTM can keep sending aditional data
  // const analytics = loadSegment();

  // TODO: Add page tracking when Nuxt 3 migration is done
  // const router = useRouter();
  // if (router) {
  //   router.afterEach((to) => {
  //     analytics.page(to.meta.tracking?.category, to.name, {
  //       path: to.fullPath,
  //     });
  //   });
  // }
});